import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-14 flex items-start justify-end p-6 px-4 py-6 pointer-events-none" }
const _hoisted_2 = { class: "w-full max-w-sm" }
const _hoisted_3 = {
  key: 0,
  class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-green-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" })
  ])
], -1)
const _hoisted_5 = { class: "px-4 py-2 -mx-3" }
const _hoisted_6 = { class: "mx-3" }
const _hoisted_7 = { class: "font-semibold text-green-500" }
const _hoisted_8 = { class: "text-sm text-gray-600" }
const _hoisted_9 = {
  key: 1,
  class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-red-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" })
  ])
], -1)
const _hoisted_11 = { class: "px-4 py-2 -mx-3" }
const _hoisted_12 = { class: "mx-3" }
const _hoisted_13 = { class: "font-semibold text-red-500" }
const _hoisted_14 = { class: "text-sm text-gray-600" }
const _hoisted_15 = {
  key: 2,
  class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-blue-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" })
  ])
], -1)
const _hoisted_17 = { class: "px-4 py-2 -mx-3" }
const _hoisted_18 = { class: "mx-3" }
const _hoisted_19 = { class: "font-semibold text-blue-500" }
const _hoisted_20 = { class: "text-sm text-gray-600" }
const _hoisted_21 = {
  key: 3,
  class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-yellow-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" })
  ])
], -1)
const _hoisted_23 = { class: "px-4 py-2 -mx-3" }
const _hoisted_24 = { class: "mx-3" }
const _hoisted_25 = { class: "font-semibold text-yellow-500" }
const _hoisted_26 = { class: "text-sm text-gray-600" }

import { Notification } from "notiwind";

export default /*#__PURE__*/_defineComponent({
  __name: 'NotifyComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_NotificationGroup = _resolveComponent("NotificationGroup")!

  return (_openBlock(), _createBlock(_component_NotificationGroup, { group: "toast-messages" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Notification), {
            enter: "transform ease-out duration-300 transition",
            "enter-from": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4",
            "enter-to": "translate-y-0 opacity-100 sm:translate-x-0",
            leave: "transition ease-in duration-500",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0",
            move: "transition duration-500",
            "move-delay": "delay-300"
          }, {
            default: _withCtx(({ notifications }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id
                }, [
                  (notification.type === 'success')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(notification.title), 1),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(notification.text), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === 'danger')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(notification.title), 1),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(notification.text), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === 'info')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(notification.title), 1),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(notification.text), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (notification.type === 'warning')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(notification.title), 1),
                            _createElementVNode("p", _hoisted_26, _toDisplayString(notification.text), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})